import request from '../../utils/request'

// 查询
export function fetchList (data) {
  // return request.post('/business/member/page', data, {
  //   trim: true
  // })
  return request.post('/business/member/findMemberInfoPage', data, {
    trim: true
  })
}
// 部门信息同步
export function memberSync (data) {
  return request.post('/business/member/syncAll', data)
}
// 导出Excel
export function exportExcel (data) {
  return request.post('/business/member/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/member/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/member/updateById', data)
}

// 批量拉黑
export function batchBlock (ids) {
  return request.get(`/business/member/batchBlock?ids=${ids}`)
}

// 重新授权
export function roleAuth (id) {
  return request.get(`/business/member/roleAuth/${id}`)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/member/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/member/delete/batch', {
    params: {
      ids
    }
  })
}
